export default __webpack_public_path__ + "static/media/th.424cf1c0.png";